var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asset-wrapper active no-edit"},[_c('div',{style:(_vm.noEditStyle),attrs:{"id":"color_asset"}},[_c('div',{staticClass:"color-bg",style:(_vm.zone.style)})])])}
var staticRenderFns = []

export { render, staticRenderFns }